// TODO - The below code is a legacy implementation. All code using this should be re-factored to use httpClient.js
import Axios from 'axios';

const { REACT_APP_API_BASE_URL } = process.env;

export const getData = async (path) => {
  const authToken = localStorage.getItem('miura_access_token');
  return new Promise((resolve) => {
    Axios.get(`${REACT_APP_API_BASE_URL}${path}`, {
      headers: { Authorization: 'Bearer ' + authToken },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        resolve(error);
      });
  });
};

export const getAbsoluteURL = (path) => {
  return `${REACT_APP_API_BASE_URL}${path}`;
};

export const getDataWithAbsoluteURL = async (absoluteURL) => {
  const authToken = localStorage.getItem('miura_access_token');
  return new Promise((resolve) => {
    Axios.get(`${absoluteURL}`, {
      headers: { Authorization: 'Bearer ' + authToken },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        resolve(error);
      });
  });
};

export const putData = async (path, data) => {
  const authToken = localStorage.getItem('miura_access_token');
  return new Promise((resolve) => {
    Axios.put(`${REACT_APP_API_BASE_URL}${path}`, data, {
      headers: { Authorization: 'Bearer ' + authToken },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        resolve(error);
      });
  });
};

export const putDataWithAbsoluteURL = async (absoluteURL, data) => {
  const authToken = localStorage.getItem('miura_access_token');
  return new Promise((resolve) => {
    Axios.put(`${absoluteURL}`, data, {
      headers: { Authorization: 'Bearer ' + authToken },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        resolve(error);
      });
  });
};

export const patchData = async (path, data) => {
  const authToken = localStorage.getItem('miura_access_token');
  return new Promise((resolve) => {
    Axios.patch(`${REACT_APP_API_BASE_URL}${path}`, data, {
      headers: { Authorization: 'Bearer ' + authToken },
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch(function (error) {
        resolve(error);
      });
  });
};
